import React from "react";
import AttributeConfigureOptions from "./AttrsOptions";
import AttributeConfigureHeader from "./AttrsHeader";
import { useSelector } from "react-redux";
const AttributeConfigurePanel = ({
  editPanel,
  setBreakdownProp,
  setXaxisProp,
}) => {
  let selectedAttributeName = editPanel?.attName;

  const WM_attributes = useSelector((state) => state.WidgetMaker.WM_attributes);
  function findAttributeObject(attributeName, dataArray) {
    for (let i = 0; i < dataArray.length; i++) {
      const innerArray = dataArray[i][1];

      if (Array.isArray(innerArray)) {
        for (let j = 0; j < innerArray.length; j++) {
          if (
            Array.isArray(innerArray[j]) &&
            innerArray[j][0] === attributeName
          ) {
            return innerArray[j][1];
          }
        }
      }
    }
    return null;
  }
  let Extractvalues = findAttributeObject(selectedAttributeName, WM_attributes);
  //console.log("extract Values", Extractvalues);
  let optionValues = Extractvalues?.values;
  let TaggingOn = Extractvalues?.sub_values;
  return (
    <div>
      <div>
        {" "}
        <AttributeConfigureHeader
          TaggingOn={TaggingOn}
          optionValues={optionValues}
          editPanel={editPanel}
          setXaxisProp={setXaxisProp}
          setBreakdownProp={setBreakdownProp}
        />
      </div>

      {/* <div style={{ marginTop: "1rem" }}>
        {" "}
        <AttributeConfigureOptions optionValues={optionValues} />
      </div> */}
    </div>
  );
};

export default AttributeConfigurePanel;
